import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id FEB9507A-DA7D-4CB3-918A-E64BBB9D4CC9
 * name play-protected-content
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/play-protected-content.svg
 * tags
 */
export const PlayProtectedContentIcon = createSvgIcon(<><path d="M2,5V18H11V16H4V7H17V11H19V5H2M9,9V14L12.5,11.5L9,9M21.04,11.67L16.09,16.62L13.96,14.5L12.55,15.91L16.09,19.45L22.45,13.09L21.04,11.67Z" /></>, 'PlayProtectedContentIcon');
export default PlayProtectedContentIcon